import { trackConfig } from '@/track/config';

import { type ITrackObject, TrackObjectsManager } from './track-objects-manager';

export const IssuePriorityValues = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    CRITICAL: 'CRITICAL'
} as const;
export type IssuePriorityType = keyof typeof IssuePriorityValues;

export const IssueStatusValues = {
    CANCEL: 'CANCEL',
    COMPLETE: 'COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    TODO: 'TODO'
} as const;
export type IssueStatusType = keyof typeof IssueStatusValues;

export interface ITrackIssue extends ITrackObject {
    title: string;
    priority: IssuePriorityType;
    status: IssueStatusType;
}

export const ISSUE_PATH = 'issue';

class TrackIssuesManager extends TrackObjectsManager<ITrackIssue> {
    public constructor() {
        super(trackConfig, ISSUE_PATH);
    }
}

export const trackIssuesManager = new TrackIssuesManager();
